import { GetRequest, PostRequestFile, PostRequest } from '../lib/request';

const ADD_SKU_TO_CART = `/cart/api/add-to-cart`;


export async function AddToCart(data){

        try{
            return await PostRequest(`${ADD_SKU_TO_CART}`, data);
        }catch(ex){
            throw new Error("Unable to add the item to the cart");
        }
}